export const PERMISSION_DENIED = 'Permission denied'
